<mat-accordion class="filters-container" multi>
  <mat-expansion-panel [expanded]="checkIfExpanded(isMobile)">
    <mat-expansion-panel-header>
      <div>
        <div class="flex justify-start items-center w-100 filters-title" *ngIf="filters?.hasTitle">
          <h2>{{ filters.title | i18n }} {{ settedFilters }}</h2>
        </div>
      </div>
    </mat-expansion-panel-header>

    <div *ngIf="filterList?.length > 0" [formGroup]="filterForm">
      <div *ngFor="let filter of filterList">
        <div>
          <div [ngSwitch]="filter.formatType" class="w-100">
            <div *ngIf="
                filter.formatType == 'text' || filter.formatType == 'text-array'
              ">
              <mat-form-field class="full-width">
                <mat-label>{{ filter.label | i18n }} </mat-label>
                <input matInput placeholder="" [formControlName]="filter.techname"
                  (change)="changeValue($event.target.value, filter)" (keydown.enter)="
                    changeValue($event.target.value, filter); confirm()
                  " [value]="filterForm?.get(filter.techname)?.value" autocomplete="off" />
                <rfc-icon matSuffix [iconInput]="setIconAttributeForRendering(filter)"></rfc-icon>
              </mat-form-field>
            </div>
            <div *ngSwitchCase="'number'">
              <mat-form-field class="full-width">
                <mat-label>{{ filter.label | i18n }} </mat-label>
                <input matInput type="number" placeholder="" [formControlName]="filter.techname"
                  (change)="changeValue($event.target.value, filter)" (keydown.enter)="
                    changeValue($event.target.value, filter); confirm()
                  " [value]="filterForm?.get(filter.techname)?.value" autocomplete="off" />
                <rfc-icon matSuffix [iconInput]="setIconAttributeForRendering(filter)"></rfc-icon>
              </mat-form-field>
            </div>
            <div *ngIf="filter.formatType == 'location-search'">
              <mat-form-field class="full-width">
                <mat-label>{{ filter.label | i18n }} </mat-label>
                <input matInput placeholder="" autocomplete="off" #search />
                <rfc-icon matSuffix [iconInput]="setIconAttributeForRendering(filter)"></rfc-icon>
              </mat-form-field>
            </div>
            <div *ngSwitchCase="
                filter.formatType == 'accordion' ||
                filter.formatType == 'grouped_accordion'
                  ? filter.formatType
                  : ''
              " class="full-width">
              <mat-accordion>
                <mat-expansion-panel>
                  <mat-expansion-panel-header class="filter-accordion-header">
                    <mat-panel-title>
                      {{ filter.label | i18n }}
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <ng-container [ngTemplateOutlet]="fieldTemplate" [ngTemplateOutletContext]="{
                      sub_filters: filter.child,
                      mainFilter: filter
                    }">
                  </ng-container>
                </mat-expansion-panel>
              </mat-accordion>
            </div>

            <div *ngSwitchCase="'multi_select'">
              <mat-form-field class="full-width">
                <mat-label>{{ filter.label | i18n }}</mat-label>
                <mat-chip-grid #chipGrid>
                  <mat-chip-row *ngFor="let option of getSelectedOptions(filter.child, filter)"
                    (removed)="removeFromMultiSelectValue(option.techname, filter)">
                    {{ option.label | i18n }}
                    <button matChipRemove aria-label="remove">
                      <mat-icon>cancel</mat-icon>
                    </button>
                  </mat-chip-row>
                </mat-chip-grid>
                <input matInput [matChipInputFor]="chipGrid" [matAutocomplete]="auto"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes" #searchInput />

                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event, filter, searchInput)">
                  <mat-option *ngFor="let option of getFilteredOptions(filter.child, searchInput.value)"
                    [value]="option.techname">
                    {{ option.label | i18n }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>
            <!---->
            <!-- <div *ngSwitchCase="'multi_select'">
              <mat-form-field class="full-width mt-1">
                <mat-label>{{ filter.label | i18n }}</mat-label>
                <mat-select
                  placeholder="{{ 'start_typing' | i18n }}"
                  [(ngModel)]="selectedOption"
                  (selectionChange)="selectedSingleOption($event, filter)"
                >
                  <mat-option *ngFor="let option of filter.child" [value]="option.techname">
                    {{ option.label | i18n }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div> -->
            <!---->
            <mat-error *ngIf="control(filterForm, filter.techname).hasError">
              {{ getErrorMessage(filter.techname) }}
            </mat-error>
          </div>
        </div>
      </div>
    </div>
    <!-- button section -->
    <div class="mt-1 flex align-center gap-[2em] justify-center">
      <button mat-raised-button (click)="discard()" class="ald-mat-button">
        {{ getButtonLabelDiscard() }}
      </button>
      <button mat-raised-button (click)="confirm()" [disabled]="filterForm.invalid" class="ald-mat-button primary">
        {{ getButtonLabelConfirm() }}
      </button>
    </div>
  </mat-expansion-panel>
</mat-accordion>

<ng-template #fieldTemplate let-sub_filters="sub_filters" let-mainFilter="mainFilter">
  <div class="sub-filter-container">
    <ng-container *ngFor="let filter of sub_filters">
      <div [ngSwitch]="filter.formatType"
        [ngStyle]="{'width':( mainFilter.custom?.displayChild == 'half' ? 46 : 100) + '%'}">
        <div *ngSwitchCase="'text'">
          <mat-form-field class="full-width">
            <mat-label>{{ filter.label | i18n }} </mat-label>
            <input matInput placeholder="" [formControlName]="filter.techname"
              (change)="changeValue($event.target.value, filter, mainFilter)" />
            <rfc-icon matSuffix [iconInput]="setIconAttributeForRendering(filter)"></rfc-icon>
          </mat-form-field>
        </div>
        <div *ngSwitchCase="'number'">
          <mat-form-field class="full-width">
            <mat-label>{{ filter.label | i18n }} </mat-label>
            <input matInput placeholder="" type="number" [formControlName]="filter.techname"
              (change)="changeValue($event.target.value, filter, mainFilter)" />
            <rfc-icon matSuffix [iconInput]="setIconAttributeForRendering(filter)"></rfc-icon>
          </mat-form-field>
        </div>
        <div *ngSwitchCase="'toggle_button'">
          <mat-button-toggle-group name="fontStyle" aria-label="Font Style" multiple style="width: 100%;">
            <mat-button-toggle class="full-width" [checked]="
                filterForm?.get(mainFilter.techname + '.' + filter.techname)
                  ?.value
              " (change)="changeValue($event.source.checked, filter, mainFilter)" [value]="filter.techname">
              {{ filter.label | i18n }}</mat-button-toggle>
          </mat-button-toggle-group>
        </div>
        <div *ngSwitchCase="'toggle_button_single'">
          <mat-button-toggle-group class="toggleBtns" name="togglefilter" aria-label="togglefilter" class="w-full">
            <div *ngFor="let element of filter.child">
              <mat-button-toggle [checked]="
              filterForm?.get(mainFilter.techname + '.' + filter.techname +'.' + element.techname)
                ?.value
            " (change)="changeValueForToggle($event.source.checked,filter,element.techname, mainFilter)"
                [value]="element.techname">
                {{ element.label | i18n }}</mat-button-toggle>
            </div>

          </mat-button-toggle-group>
        </div>
        <div *ngSwitchCase="'date_range'">
          <mat-form-field *ngIf="
              getDateRangeTechName('date_range_start', filter) &&
              getDateRangeTechName('date_range_end', filter)
            " appearance="fill" class="filter-date-range full-width">
            <mat-label>{{ "select_date_range" | i18n }}</mat-label>
            <mat-date-range-input [rangePicker]="rangePicker" [min]="filter.minDate" [max]="maxDate">
              <input disabled matStartDate placeholder="{{ 'start_date' | i18n }}" (dateChange)="
                  changeDate(
                    $event,
                    mainFilter.techname + '.' + filter.techname,
                    getDateRangeTechName('date_range_start', filter)
                  )
                " [value]="
                  getDateRangeValue(
                    filter,
                    filterForm,
                    'date_range_start',
                    mainFilter
                  )
                " />
              <input disabled matEndDate placeholder="{{ 'end_date' | i18n }}" (dateChange)="
                  changeDate(
                    $event,
                    mainFilter.techname + '.' + filter.techname,
                    getDateRangeTechName('date_range_end', filter)
                  )
                " [value]="
                  getDateRangeValue(
                    filter,
                    filterForm,
                    'date_range_end',
                    mainFilter
                  )
                " />
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="rangePicker" disabled="false"></mat-datepicker-toggle>
            <mat-date-range-picker #rangePicker disabled="false">
              <mat-date-range-picker-actions>
                <button mat-button matDateRangePickerCancel>
                  {{ "cancel" | i18n }}
                </button>
                <button mat-raised-button color="primary" matDateRangePickerApply>
                  {{ "apply" | i18n }}
                </button>
              </mat-date-range-picker-actions>
            </mat-date-range-picker>
          </mat-form-field>
        </div>

        <div *ngSwitchCase="'date_refuel'">
          <mat-form-field *ngIf="
              getDateRangeTechName('date_range_start', filter) &&
              getDateRangeTechName('date_range_end', filter)
            " appearance="fill" class="filter-date-range full-width">
            <mat-label>{{ "select_date_range" | i18n }}</mat-label>
            <mat-date-range-input [rangePicker]="rangePicker" [max]="maxDate">
              <input disabled matStartDate placeholder="{{ 'start_date' | i18n }}" (dateChange)="
                  changeDate2(
                    $event,
                    mainFilter.techname + '.' + filter.techname,
                    getDateRangeTechName('date_range_start', filter)
                  )
                " [value]="
                  getDateRangeValue(
                    filter,
                    filterForm,
                    'date_range_start',
                    mainFilter
                  )
                " />
              <input disabled matEndDate placeholder="{{ 'end_date' | i18n }}" (dateChange)="
                  changeDate2(
                    $event,
                    mainFilter.techname + '.' + filter.techname,
                    getDateRangeTechName('date_range_end', filter)
                  )
                " [value]="
                  getDateRangeValue(
                    filter,
                    filterForm,
                    'date_range_end',
                    mainFilter
                  )
                " />
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="rangePicker" disabled="false"></mat-datepicker-toggle>
            <mat-date-range-picker #rangePicker disabled="false">
              <!-- <mat-date-range-picker-actions>
                <button mat-button matDateRangePickerCancel>
                  {{ "cancel" | i18n }}
                </button>
                <button
                  mat-raised-button
                  color="primary"
                  matDateRangePickerApply
                >
                  {{ "apply" | i18n }}
                </button>
              </mat-date-range-picker-actions> -->
            </mat-date-range-picker>
          </mat-form-field>
        </div>

        <div *ngSwitchCase="'date_single'">
          <mat-form-field>
            <input matInput [matDatepicker]="singleDatePicker" placeholder="{{ 'select_single_date' | i18n }}"
              (dateChange)="changeDate($event, mainFilter.techname + '.' + filter.techname, getDateRangeTechName('date_range_start', filter))"
              [value]="getDateRangeValue(filter, filterForm, 'date_range_start', mainFilter)"
              (click)="singleDatePicker.open()">
            <mat-datepicker-toggle matSuffix [for]="singleDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #singleDatePicker></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
    </ng-container>
  </div>
</ng-template>
